<template>
    <svg
        viewBox="0 0 557 481"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="557"
        height="481"
        class="pointer-events-none">
        <mask
            id="path-1-inside-1_296_73"
            fill="white">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.88158e-05 144.185L2.47867e-05 338.809L556.427 480.572L556.427 336.387L556.427 144.185L556.427 6.15026e-05L9.28449e-05 141.763L5.88158e-05 144.185Z" />
        </mask>
        <path
            d="M2.47867e-05 338.809L-0.493751 340.747L-1.99998 340.363L-1.99998 338.809L2.47867e-05 338.809ZM5.88158e-05 144.185L-1.99994 144.185L-1.99994 144.185L5.88158e-05 144.185ZM556.427 480.572L558.427 480.572L558.427 483.146L555.933 482.51L556.427 480.572ZM556.427 336.387L558.427 336.387L558.427 336.387L556.427 336.387ZM556.427 144.185L554.427 144.185L554.427 144.185L556.427 144.185ZM556.427 6.15026e-05L555.933 -1.93803L558.427 -2.57338L558.427 6.2699e-05L556.427 6.15026e-05ZM9.28449e-05 141.763L-1.99991 141.763L-1.99989 140.209L-0.493682 139.825L9.28449e-05 141.763ZM-1.99998 338.809L-1.99994 144.185L2.00006 144.185L2.00002 338.809L-1.99998 338.809ZM555.933 482.51L-0.493751 340.747L0.4938 336.871L556.92 478.634L555.933 482.51ZM558.427 336.387L558.427 480.572L554.427 480.572L554.427 336.387L558.427 336.387ZM554.427 336.387L554.427 144.185L558.427 144.185L558.427 336.387L554.427 336.387ZM554.427 144.185L554.427 6.03063e-05L558.427 6.2699e-05L558.427 144.185L554.427 144.185ZM556.92 1.93815L0.493868 143.701L-0.493682 139.825L555.933 -1.93803L556.92 1.93815ZM2.00009 141.763L2.00006 144.185L-1.99994 144.185L-1.99991 141.763L2.00009 141.763Z"
            fill="white"
            mask="url(#path-1-inside-1_296_73)" />
    </svg>
</template>
